import React from 'react';
import './Header.css';
function Header() {
    return(
    <>
    <div className="header-container">
        <img src="https://www.planetware.com/wpimages/2020/01/india-in-pictures-beautiful-places-to-photograph-taj-mahal.jpg" alt="Photo" className="Photo-img" />
    <h1>Hi</h1>
    <h2>Ben</h2>
    <h3>Gwen</h3>
    </div>
    </>
    );
}
export default Header;